import React, { useContext, useEffect, useState } from 'react'
import { useSwipeable } from 'react-swipeable';
import { appContext } from '../App'
import { FaImage, FaAngleLeft, FaAngleRight } from 'react-icons/fa'
import { postsRef, usersRef } from '../firebase/config'
import {v4 as uuidv4} from 'uuid';
import { collection, doc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import LoadingMedia from './GENERAL-COMPONENTS/LoadingMedia';
import { functionsContext } from '../CONTEXTS/FunctionsContext';
import { checkObjectStoreExists, getFromIndexedDB, saveToIndexedDB } from '../indexedDB';



const PostForm = () => {
  const {
  showPostForm, setShowPostForm, user, day, month, year, hours, mins, period, users, allPosts, postFormFor, setPostFormFor, PostFormIDs, setPostFormIDs, setProcessingPosts, processingPosts
  } = useContext(appContext)
  const { loadMedia, callError, generateLink, } = useContext(functionsContext)

  const { postId, commentId, replyId } = PostFormIDs

  const [caption, setCaption] = useState('')
  const [media, setMedia] = useState([])
  const [files, setFiles] = useState([])
  const [rawFiles, setRawFiles] = useState([])
  const [index, setIndex] = useState(0)
  const [indexIncreasing, setIndexIncreasing] = useState(true)
  const [currentUrl, setCurrentUrl] = useState('')
  const [currentVideo, setCurrentVideo] = useState(null)
  const [currentVideoPlaying, setCurrentVideoPlaying] = useState(false)

  const time = new Date()
  


  useEffect(() => {
    if (rawFiles[0]) {
      setFiles(rawFiles)
    }
  }, [rawFiles])



  useEffect(() => {
    if (!showPostForm) {
      setCaption("")
      setMedia([])
      setIndex(prev => prev - prev)
      setIndexIncreasing(false)
      setCurrentUrl("")
      setCurrentVideo(null)
      setCurrentVideoPlaying(false)
    }
  }, [showPostForm])



  function startPostProcessing (id, files) {
    let type = ''

    if (files.length === 0) {
      type = "Text"

    } else if (files.length === 1) {
      if (files[0].type.startsWith('image/')) {
        type = "Picture-Media"
          
      } else if (files[0].type.startsWith('video/')) {
        type = "Video-Media"
      }

    } else {
      type = "Group-Media"
    }

    setProcessingPosts([{ id, caption, media, type }, ...processingPosts])
  }



  useEffect(() => {
    if (media.length !== 0 && media[index]) {
      setCurrentUrl(media[index].url)
    }

  }, [media, index])


  useEffect(() => {
    if (currentUrl !== '' && media[index]) {
      if (media[index].type === "img") {
        setCurrentVideo(null)

      } else {
        const videos = document.querySelectorAll("video");
  
        videos.forEach(video => {
          video.pause();
    
          if (video.src === currentUrl) {
            const handlePlay = () => setCurrentVideoPlaying(true);
            const handlePause = () => setCurrentVideoPlaying(false);
    
            video.removeEventListener('play', handlePlay);
            video.removeEventListener('pause', handlePause);
    
            video.addEventListener('play', handlePlay);
            video.addEventListener('pause', handlePause);
    
            setCurrentVideo(video);
          }
        });
      }
    }


    return () => {
      const videos = document.querySelectorAll("video");
      videos.forEach(video => {
        video.removeEventListener('play', () => setCurrentVideoPlaying(true));
        video.removeEventListener('pause', () => setCurrentVideoPlaying(false));
      });
    };
  }, [currentUrl, media, index]);



  useEffect(() => {
    if (!showPostForm) {
      setPostFormFor("")
      setPostFormIDs({
        postId: "", commentId: "", replyId: ""
      })
    }
  }, [showPostForm])


  async function initializePost(e) {
    e.preventDefault();
    setShowPostForm(false);

    const id = uuidv4(); 
    let type;
    if (media.length === 0) {
      if (caption === '') return;
      type = 'Text';

    } else if (media.length === 1) {
      type = media[0].type === 'img' ? 'Picture-Media' : 'Video-Media';

    } else {
      type = 'Group-Media';
    }


    const newPost = {
      id,
      type,
      caption,
      media: files,
      date: `${day}/${month}/${year}`,
      time: `${hours}:${mins} ${period}`,
      creator: user.id,
      postId: postId || '',
      commentId: commentId || '',
      replyId: replyId || '',
      createdAt: serverTimestamp(),
      likes: { value: [] },
      shares: { value: [] },
    };


    // const postFormForData = { id, newPost, postFormFor }; // Make sure to include the unique ID

    // try {
    //   // Save the post and form data to IndexedDB
    //   await saveToIndexedDB('wowi-pending-posts', postFormForData);
    //   console.log('Post saved to IndexedDB successfully.');
    // } catch (error) {
    //   console.error('Failed to save post to IndexedDB:', error);
    // }
    uploadPost(postFormFor, newPost)
  }

  


  const uploadPost = async (postFormFor, newPost) => {
    const { id, media, postId, commentId } = newPost

    startPostProcessing(id, media)

    const newMedia = media[0] ? await generateLink(media) : []


    let ref = postsRef


    if (postFormFor === 'comment') {
      ref = collection(postsRef, postId, 'comments')

    } else if (postFormFor === 'reply' || postFormFor === 'reply-reply') {
      ref = collection(postsRef, postId, 'comments', commentId, 'replies')
    }

   



    setDoc(doc(ref, id), {
      ...newPost, media: newMedia
    }).then(() => {
      callError(`${postFormFor === 'post' ? 'Post' : "Comment"} sent successfully!`)

      if (postFormFor === 'post') {
        postNotification(id)

      } else if (postFormFor === 'comment') {
        commentNotification(id)
  
      } else if (postFormFor === 'reply') {
        replyNotification(id)

      } else if (postFormFor === 'reply-reply') {
        replyReplyNotification(id)
      }

    }).catch(() => {
      callError("Your post wasn't sent. Please try again.")

    }).finally(() => {
      setProcessingPosts(
        processingPosts.filter(post => post.id !== id)
      )
      localStorage.removeItem('wowi-pending-post')
    })
  }


  function postNotification(id) {
    const notiId = uuidv4()
    const words = caption.split(/['.', '/',' ', ':', ';', ',']/)

    users.map(user => {
      const condition = words.find(word => word === `@${user?.username}`)
      const conditionII = user.id !== user.id

      if (condition && conditionII) {
        const userRef = doc(usersRef, user.id)

        updateDoc(userRef, {
          notifications: {
            value: [...user.notifications.value, {
              id: notiId,
              type: 'post-tag', 
              taggedBy: user.id,
              postId: id, 
              sentAt: time.getTime()
            }]
          }
        })
      }
    })
  }


  function commentNotification(id) {
    const post = allPosts.find(post => post.id === postId)
    const words = caption.split(/['.', '/',' ', ':', ';', ',']/)

    if (post) {
      users.map(user => {
      const condition = words.find(word => word === `@${user.username}`)
      const conditionII = user.id !== user.id

      if (condition && conditionII) {
        const userRef = doc(usersRef, user.id)
        const notiId = uuidv4()

        updateDoc(userRef, {
          notifications: {
            value: [...user.notifications.value, {
              id: notiId,
              type: 'comment-tag', 
              taggedBy: user.id,
              commentId: id, 
              postId: post.id,
              sentAt: time.getTime()
            }]
          }
        })
      }
    })


    
    const condition = post.creator !== user.id
    if (condition) {
      const userRef = doc(usersRef, post.creator)
      const creator = users.find(user => user.id === post.creator)
      const notiId = uuidv4()
      
      updateDoc(userRef, {
        notifications: {
          value: [...creator.notifications.value, {
            id: notiId,
            type: 'post-reply',
            commentId: id,
            postId: post.id,
            repliedBy: user.id,
            sentAt: time.getTime()
          }]
        }
      })
    }
    }
  }


  function replyNotification(id) {
    const post = allPosts.find(post => post.id === postId)
    const comment = post.comments.value.find(comment => comment.id === commentId)
    const words = caption.split(/['.', '/',' ', ':', ';', ',']/)

    if (post && comment) {
      users.map(user => {
        const condition = words.find(word => word === `@${user?.username}`)
        const conditionII = user.id !== user.id
  
        if (condition && conditionII) {
          const userRef = doc(usersRef, user.id)
          const notiId = uuidv4()
  
          updateDoc(userRef, {
            notifications: {
              value: [...user.notifications.value, {
                id: notiId,
                type: 'reply-tag', 
                taggedBy: user.id,
                replyId: id, 
                postId: post.id,
                commentId: comment.id,
                sentAt: time.getTime()
              }]
            }
          })
        }
      })
  
     
     
      
      const condition = comment.creator !== user.id
      if (condition) {
        const notiId = uuidv4()
        const creator = users.find(user => user.id === comment.creator)
        const userRef = doc(usersRef, creator.id)
  
        updateDoc(userRef, {
          notifications: {
            value: [...creator.notifications.value, {
              id: notiId,
              type: 'comment-reply',
              commentId: comment.id,
              postId: post.id,
              repliedBy: user.id,
              sentAt: time.getTime()
            }]
          }
        })
      }
    }
  }


  function replyReplyNotification(id) {
    const words = caption.split(/['.', '/',' ', ':', ';', ',']/)
    const post = allPosts.find(post => post.id === postId)
    const comment = post.comments.value.find(comment => comment.id === commentId)


    if (post && comment) {
      users.map(user => {
        const condition = words.find(word => word === `@${user?.username}` )
        const conditionII = user.id !== user.id
        if (condition && conditionII) {
          const userRef = doc(usersRef, user.id)
          const notiId = uuidv4()
  
          updateDoc(userRef, {
            notifications: {
              value: [...user.notifications.value, {
                id: notiId,
                type: 'reply-tag', 
                taggedBy: user.id,
                replyId: id, 
                postId: post.id,
                commentId: comment.id,
                sentAt: time.getTime()
              }]
            }
          })
        }
      })
      
      const condition = comment.creator !== user.id
      if (condition) {
        const notiId = uuidv4()
        const creator = users.find(user => user.id === comment.creator)
        const userRef = doc(usersRef, creator.id)
        
        updateDoc(userRef, {
          notifications: {
            value: [...creator.notifications.value, {
              id: notiId,
              type: 'reply-reply',
              replyId: id,
              commentId: comment.id,
              postId: post.id,
              repliedBy: user.id,
              sentAt: time.getTime()
            }]
          }
        })
      }
    }
  }


  function deleteMedia(e) {
    e.preventDefault()

    const mediaUrl = media.find((_, ind) => ind === index).url

    if (media.length === 1) {
      setMedia([])

    } else {
      setMedia(
        media.filter(media => media.url !== mediaUrl)
      )

      if (index === (media.length - 1)) {
        setIndex(index => index - 1)

      } else {
        setIndex(index => index + 1)
      }
    }
  }


  const playPauseVideo = (e) => {
    e.preventDefault()

    if (currentVideo.paused) {
      currentVideo.play(); 

    } else {
      currentVideo.pause(); 
    }
  }



  const handlers = useSwipeable({
    onSwipedLeft: () => {
      increaseIndex()
    } ,

    onSwipedRight: () => {
      decreaseIndex()
    },
  });


  function increaseIndex() {
    if (index !== media.length - 1) {
      setIndex(prev => prev + 1)
      setIndexIncreasing(true)
    }
  }


  function decreaseIndex() {
    if (index !== 0) {
      setIndex(prev => prev - 1)
      setIndexIncreasing(false)
    }
  }




  return (
    <div
      className={showPostForm ? "post-form-overlay active" : "post-form-overlay"}
    >
      <form action="submit" className='new-post-form'>
        <div className='new-post-btn-div'>
          <label htmlFor='new-post-img' >
            <span><FaImage /></span>

            <input autoComplete='off' type="file" id='new-post-img'
              name='new-post-img' onClick={e => e.target.value = null}
              onChange={e => {
                loadMedia(e.target.files, setMedia)
                setRawFiles(e.target.files)
              }} multiple='multiple'
            />
          </label>
          
          <button type='submit' onClick={e => initializePost(e)}>
            Post
          </button>
        </div>

        <div className="textarea-div">
          <textarea autoComplete='off' className='media-post-cap'
            type="text" placeholder='Type a caption...'
            style={{ display: `${media[0] ? 'block' : 'none'}` }}
            value={caption} onChange={e => setCaption(e.target.value)}>
          </textarea>

          {media.length > 0 &&
            <div className="multiple-media-div" {...handlers}>
              <button className='delete-media-btn'
                onClick={e => deleteMedia(e)}
              >
                <DeleteOutlineOutlinedIcon />
              </button>

              {media.length > 1 &&
                <>
                  <div className="post-number">
                    {index + 1}/{media.length}
                  </div>
                  
                  <div className="scroll-posts">
                    <button onClick={e => {
                    e.preventDefault()
                    decreaseIndex()
                    }}>
                      <FaAngleLeft />
                    </button>

                    <button onClick={e => {
                      e.preventDefault()
                      increaseIndex()
                    }}>
                      <FaAngleRight />
                    </button>
                  </div>
                </>
              }

              {media.map((media, ind) => {
                const { url, type } = media
                
                return (
                  <LoadingMedia
                    key={url} url={url} type={type} index={index} ind={ind}
                    media={media} indexIncreasing={indexIncreasing}
                    imgClass="new-img-post" videoClass="new-vid-post"
                  />
                )
              })}

              {currentVideo &&
                <button className="play-pause-btn"
                  onClick={(e) => playPauseVideo(e)}
                >
                  {!currentVideoPlaying ?
                    <PlayArrowIcon />
                    :
                    <PauseIcon />
                  }
                </button>
              }

            </div>
          }

          <textarea autoComplete='off' autoFocus value={caption}
            style={{ display: `${media[0] ? 'none' : 'block'}` }}
            placeholder="What's happening?" id='new-post-text'
            onChange={e => setCaption(e.target.value)}>
          </textarea> 
        </div>

        <div onClick={() => setShowPostForm(false)} className='form-cancel-btn-div'>
          <span className='form-cancel-btn'>
            Cancel
          </span>
        </div>
      </form>
    </div>
  )
}

export default PostForm




